// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.destinations_destinations_h3js1 {
  width: 216px;
  margin: 5px;
}

.destinations_routeId_UKEFi {
  font-family: GothamXNarrow-Medium;
  font-size: 28px;
  margin-right: 5px;
}

.destinations_title_j3_Fs {
  margin-right: 5px;
  font-family: GothamRounded-Medium;
  font-size: 13px;
}

.destinations_subtitle_QEX7U {
  font-family: GothamRounded-Book;
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/destinations.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EAEE,+BAA+B;AACjC","sourcesContent":[".destinations {\n  width: 216px;\n  margin: 5px;\n}\n\n.routeId {\n  font-family: GothamXNarrow-Medium;\n  font-size: 28px;\n  margin-right: 5px;\n}\n\n.title {\n  margin-right: 5px;\n  font-family: GothamRounded-Medium;\n  font-size: 13px;\n}\n\n.subtitle {\n  composes: title;\n  font-family: GothamRounded-Book;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"destinations": `destinations_destinations_h3js1`,
	"routeId": `destinations_routeId_UKEFi`,
	"title": `destinations_title_j3_Fs`,
	"subtitle": `destinations_subtitle_QEX7U destinations_title_j3_Fs`
};
module.exports = ___CSS_LOADER_EXPORT___;
